// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-password .login-field.checkbox-field {
  display: inline-flex;
  margin-bottom: 1em;
}

.personalized-welcome-back-userid {
  font-weight: bold;
}

.login-password a.not-you-link {
  margin-bottom: 16px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/LoginPassword.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".login-password .login-field.checkbox-field {\n  display: inline-flex;\n  margin-bottom: 1em;\n}\n\n.personalized-welcome-back-userid {\n  font-weight: bold;\n}\n\n.login-password a.not-you-link {\n  margin-bottom: 16px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
